(function ($) {
    // USE STRICT
    "use strict";

    $(document).ready(function() {
        var accordion_select = $('.accordion');
        accordion_select.accordion({
            "transitionSpeed": 400
        });
    });

})(jQuery);




